import { render, staticRenderFns } from "./AccountSettingNotification.vue?vue&type=template&id=f6c10e2e&scoped=true&"
import script from "./AccountSettingNotification.vue?vue&type=script&lang=js&"
export * from "./AccountSettingNotification.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingNotification.vue?vue&type=style&index=0&id=f6c10e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c10e2e",
  null
  
)

export default component.exports